const METRIC_KEYS = {
  online: [
    'OnlineNmae',
    'OnlineNrmse',
    'OnlineNBias',
    'OnlineMae',
    'OnlineRmse',
    'OnlineBias',
  ],
  metering: [
    'MeteringNmae',
    'MeteringNrmse',
    'MeteringNBias',
    'MeteringMae',
    'MeteringRmse',
    'MeteringBias',
  ],
}

const hasData = (metrics, type) =>
  METRIC_KEYS[type].some(key => metrics[key] != null)

export const getDefaultMetricsTab = metrics => {
  if (hasData(metrics, 'online')) return '1'
  if (hasData(metrics, 'metering')) return '2'
  return '1'
}
